<template>
  <v-card elevation="0">
    <v-list class="branded-background">
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon
            v-if="activeViewInstructor === 'Gradebook' && playlistSelected"
            color="white"
          >
            filter_list
          </v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title class="modal-title">
            <span
              v-if="activeViewInstructor === 'Gradebook' && playlistSelected" class="text-white"
            >
              Filter
            </span>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-list three-line style="padding:18px 24px !important; width: 530px;">
      <v-list-tile>
        <v-select
          class="width-small select-overflow"
          v-model="filtersInteraction.selectedStatus"
          :items="filtersInteraction.status"
          label="Status"
          solo
        ></v-select>
      </v-list-tile>
    </v-list>
    <v-card-actions class="row-space" style="height:56px">
      <v-btn
        flat
        class="branded-grey"
        @click="closeMenu()"
      >
        Cancel
      </v-btn>
      <div class="row-center">
        <v-btn
          flat
          text
          class="branded-text"
          @click="clearFilterPlaylists"
        >
          Clear Filters
        </v-btn>
        <v-btn
          v-if="activeViewInstructor === 'Gradebook' && playlistSelected"
          class="branded-background text-white"
          @click="setFiltersPlaylists"
        >
          Filter
        </v-btn>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import _ from 'lodash';
export default {
  name: 'PlaylistCompletionFilters',
  computed: {
    ...mapState('instructors', [
      'sectionPlaylists',
    ]),
    ...mapState([
      'dashModal',
    ]),
    ...mapGetters([
      'popoverToggles',
    ]),
    ...mapGetters('instructors', [
      'filtersInteraction',
      'activeViewInstructor',
    ]),
  },
  methods: {
    ...mapMutations('instructors', [
      'setFiltersInteractions',
      'setQueryParams',
    ]),
    closeMenu(){
      this.popoverToggles.filterMenuPlaylist = false;
    },
    clearFilterPlaylists: function(){
      this.setFiltersInteractions({
        selectedStatus: 'All',
        showPointsBadges: false,
        localShowPointsBadges: false,
        isFiltered: false,
        refreshData: this.filtersInteraction.selectedStatus !== 'All',
      });
      this.closeMenu();
    },
    setFiltersPlaylists(){
      this.setQueryParams({sort:'', page:1, per_page:20});
      const selectedStatus = this.filtersInteraction.selectedStatus.length ? this.filtersInteraction.selectedStatus : 'All';
      this.setFiltersInteractions({
        selectedStatus,
        showPointsBadges: this.filtersInteraction.localShowPointsBadges,
        localShowPointsBadges: this.filtersInteraction.localShowPointsBadges,
        refreshData: selectedStatus !== 'All',
        isFiltered: (
          selectedStatus !== 'All'
          || this.filtersInteraction.localShowPointsBadges
        ),
      });
      this.closeMenu();
    },
    playlistSelected() {
      return _.find(this.sectionPlaylists, { 'id': this.selectedPlaylist });
    },
  },
};
</script>